import parse from 'html-react-parser';

const IntroductionHeadline = ({ headline, preHeadline, children }) => {
  return (
    <article className="rlx-grid">
      <div className="col-span-6 place-self-start mb-6">
        {preHeadline && <span class="body-20 !font-bold">{preHeadline}</span>}
        <h1 className="headline-50 text-brown">{parse(headline)}</h1>
      </div>
      <div className="col-span-6 place-self-start body-20">
        {children}
      </div>
    </article>
  )
};

export default IntroductionHeadline;
